export const AppBarSx = {
  borderTop: "2px solid #2C2C2C",
  marginTop: {
    xs: "50px",
    sm: "100px",
  },
  padding: {
    xs: "40px 0",
    sm: "50px 0",
  },
  justifyContent: "center",
};

export const ContainerSx = {
  flex: 1,
  display: "flex",
  gap: {
    xs: "40px",
    md: "0px",
  },
  justifyContent: {
    xs: "center",
    md: "space-between",
  },
  alignItems: "center",
  flexDirection: {
    xs: "column",
    md: "row",
  },
};
export const FooterBoxSx = {
  display: "flex",
  gap: {
    xs: "30px",
    sm: "60px",
  },
  paddingLeft: { xs: 0, md: "18px" },
  alignItems: "center",
  flexDirection: { xs: "column", sm: "row" },
};

export const ButtonSx = {
  my: 2,
  color: "white",
  display: "block",
  width: "100px",
};

export const FooterBox2Sx = {
  display: "flex",
  gap: "40px",
  paddingRight: { xs: 0, md: "18px" },
  justifyContent: "center",
};

export const socialIconSx = { width: "48px", height: "48px" };
